module.exports = __webpack_public_path__ + "img/sales-screenshot.32899969.png";